import React from 'react'
import styles from './Website.module.css';
import { Link } from "react-router-dom";
import Client from '../../images/MainPage/Client.svg';
import FAQ from '../../images/MainPage/FAQ.svg';
import Partner from '../../images/MainPage/Partner.svg';
import Team from '../../images/MainPage/Team.svg';
import Testimonials from '../../images/MainPage/Testimonials.svg';

function Website() {
    return (
        <div className={styles.cardscontainer}>
            
            <Link to="blogs">
                <div className={styles.cards}>
                    <img src={Partner} alt="blogs"></img>
                    <h2>Blogs</h2>
                </div>
            </Link>
            <Link to="clientlogos">
                <div className={styles.cards}>
                    <img src={Client} alt="Admin"></img>
                    <h2>Client Logos Home</h2>
                </div>
            </Link>
            <Link to="clientlogospage">
                <div className={styles.cards}>
                    <img src={Client} alt="Admin"></img>
                    <h2>Client Logos Page</h2>
                </div>
            </Link>
            <Link to="team">
                <div className={styles.cards}>
                    <img src={Partner} alt="blogs"></img>
                    <h2>Team</h2>
                </div>
            </Link>
            <Link to="sellerlogos">
                <div className={styles.cards}>
                    <img src={Partner} alt="Admin"></img>
                    <h2>Seller Logos</h2>
                </div>
            </Link>
            <Link to="testimonials">
                <div className={styles.cards}>
                    <img src={Testimonials} alt="Admin"></img>
                    <h2>Testimonials</h2>
                </div>
            </Link>
           
            <Link to="/faqs">
                <div className={styles.cards}>
                    <img src={FAQ} alt="Admin"></img>
                    <h2>FAQ</h2>
                </div>
            </Link>
        </div>
    )
}

export default Website
